'use strict';

exports.onRouteUpdate = function (_ref, _ref2) {
  var prevLocation = _ref.prevLocation;
  var _ref2$trackPage = _ref2.trackPage,
      trackPage = _ref2$trackPage === undefined ? true : _ref2$trackPage,
      _ref2$trackPageOnRout = _ref2.trackPageOnRouteUpdate,
      trackPageOnRouteUpdate = _ref2$trackPageOnRout === undefined ? true : _ref2$trackPageOnRout,
      _ref2$trackPageOnRout2 = _ref2.trackPageOnRouteUpdateDelay,
      trackPageOnRouteUpdateDelay = _ref2$trackPageOnRout2 === undefined ? 50 : _ref2$trackPageOnRout2,
      _ref2$delayLoadUntilA = _ref2.delayLoadUntilActivity,
      delayLoadUntilActivity = _ref2$delayLoadUntilA === undefined ? false : _ref2$delayLoadUntilA,
      _ref2$delayLoadUntilA2 = _ref2.delayLoadUntilActivityAdditionalDelay,
      delayLoadUntilActivityAdditionalDelay = _ref2$delayLoadUntilA2 === undefined ? 0 : _ref2$delayLoadUntilA2,
      _ref2$includeTitleInT = _ref2.includeTitleInTrackPage,
      includeTitleInTrackPage = _ref2$includeTitleInT === undefined ? false : _ref2$includeTitleInT;

  console.log({
    prevLocation: prevLocation,
    trackPage: trackPage,
    trackPageOnRouteUpdate: trackPageOnRouteUpdate,
    trackPageOnRouteUpdateDelay: trackPageOnRouteUpdateDelay,
    delayLoadUntilActivity: delayLoadUntilActivity,
    delayLoadUntilActivityAdditionalDelay: delayLoadUntilActivityAdditionalDelay,
    includeTitleInTrackPage: includeTitleInTrackPage
  });

  if (delayLoadUntilActivity && prevLocation) {
    var additionalLoadDelay = Math.max(0, delayLoadUntilActivityAdditionalDelay || 0);

    console.log({ additionalLoadDelay: additionalLoadDelay });

    if (additionalLoadDelay) {
      var trackPageCb = function trackPageCb() {
        console.log('track page cb');

        return trackPageFn(additionalLoadDelay);
      };

      setTimeout(function () {
        console.log('delayed load timeout');
        var callbackWasQueued = loaderCallback(trackPageCb);
        console.log({ callbackWasQueued: callbackWasQueued });
        if (!callbackWasQueued) {
          trackPageCb();
        }
      }, additionalLoadDelay);
    } else {
      var callbackWasQueued = loaderCallback(trackPageFn);
      if (!callbackWasQueued) {
        trackPageFn();
      }
    }

    return;
  }

  trackPageFn();
  return;

  function pageviewCallback() {
    if (window.gatsbyPluginSegmentPageviewCaller) {
      window.gatsbyPluginSegmentPageviewCaller();
    } else if (window.analytics) {
      window.analytics.page(includeTitleInTrackPage ? document.title : undefined);
    }
  }

  function trackPageFn() {
    var alreadyDelayedBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (!(trackPage && trackPageOnRouteUpdate)) {
      return;
    }

    var delay = Math.max(0, trackPageOnRouteUpdateDelay || 0) - alreadyDelayedBy;
    console.log({
      delay: delay,
      trackPageOnRouteUpdateDelay: trackPageOnRouteUpdateDelay,
      alreadyDelayedBy: alreadyDelayedBy
    });
    if (delay > 0) {
      setTimeout(pageviewCallback, delay);
    } else {
      pageviewCallback();
    }
  }

  function loaderCallback(cb) {
    if (window.gatsbyPluginSegmentLoader) {
      window.gatsbyPluginSegmentLoader(cb);
      return true;
    }
  }
};